import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { Content } from './content';

export const LightBox = ({ visible, isAddToCart, onClose, addProductToCart }) => (
  <Lightbox opened={visible} onClose={onClose} additionalClassNames={['catalog_delivery__lightbox', 'info-lightbox']}>
    <Content onClose={onClose} addProductToCart={addProductToCart} isAddToCart={isAddToCart} />
  </Lightbox>
);

LightBox.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
